export default __webpack_public_path__ + "static/media/Logo.fa158ed3.png";